import Vue from 'vue';
const that = new Vue();

// 获取所有国家字典
export let country = null;
export const countryFn = function (time = 100, accumulation = 100000) {
  let times = null;
  that.$FN.get("infomation/myCommon/processingDict?moduleType=2&dictType=country").then(res => {
    clearTimeout(times);
    times = null;
    res && (res.code == 200) ? country = res.data : times = setTimeout(() => countryFn(time + accumulation), time);
  });
};

// 获取行业字典 国别投资/发展流程/行业发展流程字典
export let industryClassification = null;
export const industryClassificationFn = function (time = 100, accumulation = 100000) {
  let times = null;
  that.$FN.get("infomation/myCommon/processingDict?moduleType=4&dictType=industry_classification").then(res => {
    clearTimeout(times);
    times = null;
    res && (res.code == 200) ? industryClassification = res.data : times = setTimeout(() => industryClassificationFn(time + accumulation), time);
  });
};

// 获取语言
export let language = null;
export const languageFn = function (time = 100, accumulation = 100000) {
  let times = null;
  that.$FN.get("infomation/myCommon/processingDict?moduleType=2&dictType=language").then(res => {
    clearTimeout(times);
    times = null;
    res && (res.code == 200) ? language = res.data : times = setTimeout(() => languageFn(time + accumulation), time);
  });
};

// 获取翻译方向
export let transLanguagePes = null;
export const transLanguagePesFn = function (time = 100, accumulation = 100000) {
  let times = null;
  that.$FN.get("system/dict/data/type/trans_language_pes").then(res => {
    clearTimeout(times);
    times = null;
    res && (res.code == 200) ? transLanguagePes = res.data : times = setTimeout(() => transLanguagePesFn(time + accumulation), time);
  });
};

// 获取人工翻译方向
export let transLanguagePesLabour = null;
export const transLanguagePesLabourFn = function (time = 100, accumulation = 100000) {
  let times = null;
  let config = { contentType: "1" };
  that.$FN.post("api/translate-client/dict/find_by_type", { dictType: "language" }, config).then(res => {
    clearTimeout(times);
    times = null;
    res && (res.code == 100) ? transLanguagePesLabour = res.entity : times = setTimeout(() => transLanguagePesLabourFn(time + accumulation), time);
  });
};

// 获取机翻订单状态
export let orderStatusPes = null;
export const orderStatusPesFn = function (time = 100, accumulation = 100000) {
  let times = null;
  that.$FN.get("system/dict/data/type/order_status_pes").then(res => {
    clearTimeout(times);
    times = null;
    res && (res.code == 200) ? orderStatusPes = res.data : times = setTimeout(() => orderStatusPesFn(time + accumulation), time);
  });
};

// 获取人工翻译订单状态
export let peopleOrderStatus = null;
export const peopleOrderStatusFn = function (time = 100, accumulation = 100000) {
  let times = null;
  let config = { contentType: "1" };
  that.$FN.post("api/translate-client/dict/find_by_type", { dictType: "order_state" }, config).then(res => {
    clearTimeout(times);
    res && (res.code == 100) ? peopleOrderStatus = res.entity : times = setTimeout(() => peopleOrderStatusFn(time + accumulation), time);
  });
};

// 获取翻译类型状态字典
export let transTypePes = null;
export const transTypePesFn = function (time = 100, accumulation = 100000) {
  let times = null;
  that.$FN.get("system/dict/data/type/trans_type_pes").then(res => {
    clearTimeout(times);
    res && (res.code == 200) ? transTypePes = res.data : times = setTimeout(() => transTypePesFn(time + accumulation), time);
  });
};

// 获取ics
export let icsTree = null;
export const icsTreeFn = function (time = 100, accumulation = 100000) {
  let times = null;
  that.$FN.get("api/product_service/std_es/icsTree").then(res => {
    clearTimeout(times);
    res && (res.code == 100) ? icsTree = res.entity : times = setTimeout(() => icsTreeFn(time + accumulation), time);
  });
};

// 获取ccs
export let ccsTree = null;
export const ccsTreeFn = function (time = 100, accumulation = 100000) {
  let times = null;
  that.$FN.get("api/product_service/std_es/ccsTree").then(res => {
    clearTimeout(times);
    res && (res.code == 100) ? ccsTree = res.entity : times = setTimeout(() => ccsTreeFn(time + accumulation), time);
  });
};

// 获取专业
export let standardSpecialty = null;
export const standardSpecialtyFn = function (time = 100, accumulation = 100000) {
  let times = null;
  let form = { type: "standard_specialty" };
  that.$FN.get("api/product_service/dict_manage/list_by_type", form).then(res => {
    clearTimeout(times);
    res && (res.code == 100) ? standardSpecialty = res.entity : times = setTimeout(() => standardSpecialtyFn(time + accumulation), time);
  });
};

// 获取细分专业
export let professionType = null;
export const professionTypeFn = function (time = 100, accumulation = 100000) {
  let times = null;
  let form = { type: "standard_deepspecialty", pidCode: 10 };
  that.$FN.get("api/product_service/dict_manage/list_by_type", form).then(res => {
    clearTimeout(times);
    res && (res.code == 100) ? professionType = res.entity : times = setTimeout(() => professionTypeFn(time + accumulation), time);
  });
};

// 获取标准来源
export let resource = null;
export const resourceFn = function (time = 100, accumulation = 100000) {
  let times = null;
  let form = { type: "standard_resource" };
  that.$FN.get("api/product_service/dict_manage/list_by_type", form).then(res => {
    clearTimeout(times);
    res && (res.code == 100) ? resource = res.entity : times = setTimeout(() => resourceFn(time + accumulation), time);
  });
};

// 获取标准语言
export let standardLanguage = null;
export const standardLanguageFn = function (time = 100, accumulation = 100000) {
  let times = null;
  let form = { type: "standard_language" };
  that.$FN.get("api/product_service/dict_manage/list_by_type", form).then(res => {
    clearTimeout(times);
    res && (res.code == 100) ? standardLanguage = res.entity : times = setTimeout(() => standardLanguageFn(time + accumulation), time);
  });
};

// 获取标准状态
export let standardStatus = null;
export const standardStatusFn = function (time = 100, accumulation = 100000) {
  let times = null;
  let form = { type: "standard_status" };
  that.$FN.get("api/product_service/dict_manage/list_by_type", form).then(res => {
    clearTimeout(times);
    res && (res.code == 100) ? standardStatus = res.entity : times = setTimeout(() => standardStatusFn(time + accumulation), time);
  });
};

// 项目类型
export let domesticProject = null;
export const domesticProjectFn = function (time = 100, accumulation = 100000) {
  let times = null;
  let form = { type: "project_type" };
  that.$FN.get("api/product_service/dict_manage/list_by_type", form).then(res => {
    clearTimeout(times);
    res && (res.code == 100) ? domesticProject = res.entity : times = setTimeout(() => domesticProjectFn(time + accumulation), time);
  });
};

// 项目类别
export let projectCategory = null;
export const projectCategoryFn = function (time = 100, accumulation = 100000) {
  let times = null;
  let form = { type: "project_category" };
  that.$FN.get("api/product_service/dict_manage/list_by_type", form).then(res => {
    clearTimeout(times);
    res && (res.code == 100) ? projectCategory = res.entity : times = setTimeout(() => projectCategoryFn(time + accumulation), time);
  });
};

// 项目阶段
export let projectStage = null;
export const projectStageFn = function (time = 100, accumulation = 100000) {
  let times = null;
  let form = { type: "project_stage" };
  that.$FN.get("api/product_service/dict_manage/list_by_type", form).then(res => {
    clearTimeout(times);
    res && (res.code == 100) ? projectStage = res.entity : times = setTimeout(() => projectStageFn(time + accumulation), time);
  });
};

export default [
  icsTreeFn,
  ccsTreeFn,
  countryFn,
  industryClassificationFn,
  languageFn,
  transTypePesFn,
  transLanguagePesFn,
  transLanguagePesLabourFn,
  orderStatusPesFn,
  peopleOrderStatusFn,
  professionTypeFn,
  standardSpecialtyFn,
  resourceFn,
  standardLanguageFn,
  standardStatusFn,
  domesticProjectFn,
  projectCategoryFn,
  projectStageFn
]